// src/components/pwa/EnableNotificationsBanner.jsx
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { isPushSupported, isStandaloneDisplay } from '../../services/NotificationService';
import NotificationPermissionButton from './NotificationPermissionButton';

const DISMISS_KEY = 'waffle_notif_banner_dismissed';

// Positioned above UpdateAvailableBanner (bottom-4) so the two never overlap
// if both happen to be visible at once.
const EnableNotificationsBanner = () => {
  const { user } = useAuth();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const evaluate = async () => {
      if (
        !user ||
        localStorage.getItem(DISMISS_KEY) ||
        !isStandaloneDisplay() ||
        typeof Notification === 'undefined' ||
        Notification.permission !== 'default'
      ) {
        if (!cancelled) setVisible(false);
        return;
      }

      const supported = await isPushSupported();
      if (!cancelled) setVisible(supported);
    };

    evaluate();
    return () => {
      cancelled = true;
    };
  }, [user]);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="alert"
      className="fixed bottom-20 inset-x-4 mx-auto z-40 flex flex-wrap items-center gap-3 rounded-lg border-l-4 border-amber-500 bg-amber-50 text-amber-900 shadow-lg px-4 py-3 max-w-md"
    >
      <span className="text-sm font-medium">
        Get updates on your orders (and the occasional offer). Enable notifications?
      </span>
      <NotificationPermissionButton
        onGranted={dismiss}
        onDenied={dismiss}
        className="text-sm font-semibold text-amber-900 underline hover:no-underline whitespace-nowrap"
      />
      <button
        onClick={dismiss}
        className="text-sm text-amber-700 hover:text-amber-900 whitespace-nowrap"
      >
        Not now
      </button>
    </div>
  );
};

export default EnableNotificationsBanner;
